import axios from '../../utils/axiosConfig';
import {
  APPOINTMENT_CREATE_REQUEST,
  APPOINTMENT_CREATE_SUCCESS,
  APPOINTMENT_CREATE_FAIL,
  APPOINTMENT_LIST_REQUEST,
  APPOINTMENT_LIST_SUCCESS,
  APPOINTMENT_LIST_FAIL,
  APPOINTMENTS_BY_CASE_REQUEST,
  APPOINTMENTS_BY_CASE_SUCCESS,
  APPOINTMENTS_BY_CASE_FAIL,
  APPOINTMENT_DETAILS_REQUEST,
  APPOINTMENT_DETAILS_SUCCESS,
  APPOINTMENT_DETAILS_FAIL,
  APPOINTMENT_UPDATE_REQUEST,
  APPOINTMENT_UPDATE_SUCCESS,
  APPOINTMENT_UPDATE_FAIL,
  APPOINTMENT_DELETE_REQUEST,
  APPOINTMENT_DELETE_SUCCESS,
  APPOINTMENT_DELETE_FAIL,
} from '../constants/appointmentConstants';

export const createAppointment = (appointment) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_CREATE_REQUEST });
    console.log("appointment", appointment);
    const { data } = await axios.post('/api/appointments', appointment);
    dispatch({ type: APPOINTMENT_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: APPOINTMENT_CREATE_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const listAppointments = () => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_LIST_REQUEST });
    const { data } = await axios.get('/api/appointments');
    dispatch({ type: APPOINTMENT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: APPOINTMENT_LIST_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const getAppointmentsByCaseId = (caseId) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENTS_BY_CASE_REQUEST });
    const { data } = await axios.get(`/api/appointments/case/${caseId}`);
    dispatch({ type: APPOINTMENTS_BY_CASE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: APPOINTMENTS_BY_CASE_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const fetchAppointment = (id) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_DETAILS_REQUEST });
    const { data } = await axios.get(`/api/appointments/${id}`);
    dispatch({ type: APPOINTMENT_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: APPOINTMENT_DETAILS_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const updateAppointment = (appointment) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_UPDATE_REQUEST });
    console.log("appointment", appointment);
    const { data } = await axios.put(`/api/appointments/${appointment._id}`, appointment);
    dispatch({ type: APPOINTMENT_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: APPOINTMENT_UPDATE_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const deleteAppointment = (id) => async (dispatch) => {
  try {
    dispatch({ type: APPOINTMENT_DELETE_REQUEST });
    await axios.delete(`/api/appointments/${id}`);
    dispatch({ type: APPOINTMENT_DELETE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({
      type: APPOINTMENT_DELETE_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};
